import { c as _c } from "react/compiler-runtime";
import * as React from "react";
interface QuoteIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}
function QuoteIcon(t0) {
  const $ = _c(17);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t1 = React.useId();
  let t2;
  if ($[3] !== t1) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /:/g;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = t1.replace(t3, "");
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const clipId = `quote-clip-${t2}`;
  const t3 = `url(#${clipId})`;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M4.49438 34.9519C1.68539 31.8761 0 28.5206 0 22.9283C0 13.1416 7.02247 4.47341 16.8539 -0.000488281L19.382 3.63456C10.1124 8.6677 8.14607 15.0989 7.58427 19.2932C8.98876 18.4544 10.9551 18.1747 12.9213 18.4544C17.9775 19.0136 21.9101 22.9283 21.9101 28.241C21.9101 30.7576 20.7865 33.2742 19.1011 35.2315C17.1348 37.1888 14.8876 38.0277 12.0787 38.0277C8.98876 38.0277 6.17978 36.6296 4.49438 34.9519ZM32.5843 34.9519C29.7753 31.8761 28.0899 28.5206 28.0899 22.9283C28.0899 13.1416 35.1124 4.47341 44.9438 -0.000488281L47.4719 3.63456C38.2022 8.6677 36.236 15.0989 35.6742 19.2932C37.0787 18.4544 39.0449 18.1747 41.0112 18.4544C46.0674 19.0136 50 22.9283 50 28.241C50 30.7576 48.8764 33.2742 47.191 35.2315C45.5056 37.1888 42.9775 38.0277 40.1685 38.0277C37.0787 38.0277 34.2697 36.6296 32.5843 34.9519Z" fill="#525B65" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <g clipPath={t3}>{t4}</g>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <rect width="50" height="38.0282" fill="white" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== clipId) {
    t7 = <defs><clipPath id={clipId}>{t6}</clipPath></defs>;
    $[10] = clipId;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== className || $[13] !== props || $[14] !== t5 || $[15] !== t7) {
    t8 = <svg xmlns="http://www.w3.org/2000/svg" width="50" height="39" viewBox="0 0 50 39" fill="none" aria-hidden={true} className={className} {...props}>{t5}{t7}</svg>;
    $[12] = className;
    $[13] = props;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
export default React.memo(QuoteIcon);